import { ibanFormatter } from '@asn/formatters';

import { NgTemplateOutlet } from '@angular/common';
import { AfterViewInit, Component, ViewEncapsulation, inject, input } from '@angular/core';
import { FormsModule, NgControl } from '@angular/forms';

import { ApContentService } from '@ap/content';
import { ApFormErrorsComponent } from '@ap/form/errors';
import { ApIconComponent } from '@ap/icon';
import { AbstractInputComponent, ApAutocompleteFilterService, ApAutocompleteModule } from '@ap/input';
import { ApInputConstraintService } from '@ap/input/constraint';
import { ApSuggestionComponent } from '@ap/input/suggestion';
import { ApIbanValidator } from '@ap/input/validators';
import { RekeningvalidatieResource } from '@ap/interface-apic-rekeningvalidatie';

import content from './iban-input.content.json';

@Component({
    selector: 'ap-iban-input',
    templateUrl: '../../../src/lib/input.component.html',
    styleUrls: ['../../../src/lib/input.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    imports: [FormsModule, ApIconComponent, ApSuggestionComponent, ApFormErrorsComponent, ApAutocompleteModule, NgTemplateOutlet],
    providers: [ApInputConstraintService]
})
export class ApIbanInputComponent extends AbstractInputComponent implements AfterViewInit {
    protected control = inject(NgControl, { self: true, optional: true });
    protected readonly inputConstraintService = inject(ApInputConstraintService);
    protected readonly contentService = inject(ApContentService);
    private readonly rekeningvalidatieResource = inject(RekeningvalidatieResource);
    protected readonly filterService = inject(ApAutocompleteFilterService);

    /**
     * Whether to allow non sepa input.
     * Defaults to false
     */
    public readonly allowNonSepa = input(false);

    /**
     * Characters that are stripped
     */
    protected readonly stripPattern = input<RegExp>(/[^a-z0-9\s]/gi);

    constructor() {
        super();
        this.setDefaultContent(content, 'iban-input');
    }

    /**
     * After init bind the control validation
     */
    public ngAfterViewInit(): void {
        this.setValidation();
    }

    /**
     * Format value as iban.
     * Called on blur of input
     */
    protected formatValue(value: string): string {
        return ibanFormatter.format(value);
    }

    /**
     * Format as human readable iban
     */
    protected formatValueDisplay(value: string): string {
        return ibanFormatter.formatDisplay(value);
    }

    /**
     * Add Iban validators.
     */
    private setValidation() {
        const control = this.control?.control;
        if (control) {
            control.addAsyncValidators([ApIbanValidator.createValidator(this.rekeningvalidatieResource, this.allowNonSepa())]);
            control.updateValueAndValidity();
        }
    }
}
